export { default } from './ProductDetailSection';
